import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import gr.tech.site.components.layouts.ArticleLayout as _gr_tech_site_components_layouts_ArticleLayout
import gr.tech.site.components.layouts.MarkdownLayout as _gr_tech_site_components_layouts_MarkdownLayout
import gr.tech.site.components.layouts.PageLayout as _gr_tech_site_components_layouts_PageLayout
import gr.tech.site.pages.ArticlesPage as _gr_tech_site_pages_ArticlesPage
import gr.tech.site.pages.BlogsPage as _gr_tech_site_pages_BlogsPage
import gr.tech.site.pages.ContactUsPage as _gr_tech_site_pages_ContactUsPage
import gr.tech.site.pages.FaqPage as _gr_tech_site_pages_FaqPage
import gr.tech.site.pages.HomePage as _gr_tech_site_pages_HomePage
import gr.tech.site.pages.MeetTheTeamPage as _gr_tech_site_pages_MeetTheTeamPage
import gr.tech.site.pages.PartnersPage as _gr_tech_site_pages_PartnersPage
import gr.tech.site.pages.PodcastPage as _gr_tech_site_pages_PodcastPage
import gr.tech.site.pages.PrivacyPage as _gr_tech_site_pages_PrivacyPage
import gr.tech.site.pages.StatesPage as _gr_tech_site_pages_StatesPage
import gr.tech.site.pages.TermsPage as _gr_tech_site_pages_TermsPage
import gr.tech.site.pages.article.BrightiningthefuturePage as _gr_tech_site_pages_article_BrightiningthefuturePage
import gr.tech.site.pages.article.CashbackforgrowersPage as _gr_tech_site_pages_article_CashbackforgrowersPage
import gr.tech.site.pages.article.EnergysavingsPage as _gr_tech_site_pages_article_EnergysavingsPage
import gr.tech.site.pages.article.Guidetocannabisrebates2026Page as _gr_tech_site_pages_article_Guidetocannabisrebates2026Page
import gr.tech.site.pages.article.HowenergyincentivesPage as _gr_tech_site_pages_article_HowenergyincentivesPage
import gr.tech.site.pages.article.RebatevsincentivePage as _gr_tech_site_pages_article_RebatevsincentivePage
import gr.tech.site.pages.article.TheenergyefficiencyboomincannabisPage as _gr_tech_site_pages_article_TheenergyefficiencyboomincannabisPage
import gr.tech.site.pages.article.Top10highefficiencyledrebatesPage as _gr_tech_site_pages_article_Top10highefficiencyledrebatesPage
import gr.tech.site.pages.article.WhyyoushouldPage as _gr_tech_site_pages_article_WhyyoushouldPage
import gr.tech.site.pages.blog.GreenreabteswinsprestigiousPage as _gr_tech_site_pages_blog_GreenreabteswinsprestigiousPage
import gr.tech.site.pages.blog.HallofflowersPage as _gr_tech_site_pages_blog_HallofflowersPage
import gr.tech.site.pages.blog.Luckyleaf2026Page as _gr_tech_site_pages_blog_Luckyleaf2026Page
import gr.tech.site.pages.blog.LuckyleafrecapPage as _gr_tech_site_pages_blog_LuckyleafrecapPage
import gr.tech.site.pages.blog.Necann2026recapPage as _gr_tech_site_pages_blog_Necann2026recapPage
import gr.tech.site.pages.blog.Oregoncannabis2026Page as _gr_tech_site_pages_blog_Oregoncannabis2026Page
import gr.tech.site.pages.blog.SaveruralmichiganPage as _gr_tech_site_pages_blog_SaveruralmichiganPage
import gr.tech.site.pages.blog.ThethcgirlsPage as _gr_tech_site_pages_blog_ThethcgirlsPage
import gr.tech.site.pages.blog.WemadethelistPage as _gr_tech_site_pages_blog_WemadethelistPage
import gr.tech.site.pages.landings.CannabisRebatesPage as _gr_tech_site_pages_landings_CannabisRebatesPage
import gr.tech.site.pages.landings.DehumidifierRebatesPage as _gr_tech_site_pages_landings_DehumidifierRebatesPage
import gr.tech.site.pages.landings.EnergyRebatesIncentivesPage as _gr_tech_site_pages_landings_EnergyRebatesIncentivesPage
import gr.tech.site.pages.landings.FinancingPage as _gr_tech_site_pages_landings_FinancingPage
import gr.tech.site.pages.landings.HvacRebatesPage as _gr_tech_site_pages_landings_HvacRebatesPage
import gr.tech.site.pages.landings.LEDRebatesPage as _gr_tech_site_pages_landings_LEDRebatesPage
import gr.tech.site.pages.states.CaliforniaPage as _gr_tech_site_pages_states_CaliforniaPage
import gr.tech.site.pages.states.MichiganPage as _gr_tech_site_pages_states_MichiganPage
import gr.tech.site.pages.states.MinnesotaPage as _gr_tech_site_pages_states_MinnesotaPage
import gr.tech.site.pages.states.OregonPage as _gr_tech_site_pages_states_OregonPage
import gr.tech.site.pages.states.WashingtonPage as _gr_tech_site_pages_states_WashingtonPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Green Rebates"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "gr.tech.site.components.layouts.ArticleLayout",
            parentLayoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.components.layouts.initArticleLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _gr_tech_site_components_layouts_ArticleLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "gr.tech.site.components.layouts.MarkdownLayout",
            parentLayoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _gr_tech_site_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "gr.tech.site.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _gr_tech_site_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_HomePage()
        }
        ctx.router.register(
            "/article",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initArticlesPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_ArticlesPage()
        }
        ctx.router.register(
            "/article/brightening-the-future-of-agriculture-the-role-of-led-lighting-in-reap",
            layoutId = "gr.tech.site.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.article.initBrightiningthefuturePage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_article_BrightiningthefuturePage()
        }
        ctx.router.register(
            "/article/cash-back-for-growers-a-step-by-step-roadmap-to-utility-incentives",
            layoutId = "gr.tech.site.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.article.initCashbackforgrowersPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_article_CashbackforgrowersPage()
        }
        ctx.router.register(
            "/article/energy-savings-great-financial-savings-even-better-benefits-switching-led-grow-lights",
            layoutId = "gr.tech.site.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.article.initEnergysavingsPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_article_EnergysavingsPage()
        }
        ctx.router.register(
            "/article/how-energy-incentives-and-green-rebates-are-leading-the-way-in-paving-the-way-for-sustainability-in-the-indoor-ag-space",
            layoutId = "gr.tech.site.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.article.initHowenergyincentivesPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_article_HowenergyincentivesPage()
        }
        ctx.router.register(
            "/article/rebates-incentives-for-indoor-growers-what-you-need-to-know",
            layoutId = "gr.tech.site.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.article.initRebatevsincentivePage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_article_RebatevsincentivePage()
        }
        ctx.router.register(
            "/article/the-2026-guide-to-cannabis-rebates-how-to-get-paid-for-your-grow-upgrades",
            layoutId = "gr.tech.site.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.article.initGuidetocannabisrebates2026Page(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_article_Guidetocannabisrebates2026Page()
        }
        ctx.router.register(
            "/article/the-energy-efficiency-boom-in-cannabis",
            layoutId = "gr.tech.site.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.article.initTheenergyefficiencyboomincannabisPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_article_TheenergyefficiencyboomincannabisPage()
        }
        ctx.router.register(
            "/article/top-10-high-efficiency-led-rebates-for-commercial-cultivators-in-2026",
            layoutId = "gr.tech.site.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.article.initTop10highefficiencyledrebatesPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_article_Top10highefficiencyledrebatesPage()
        }
        ctx.router.register(
            "/article/why-you-should-use-a-rebate-company-for-your-horticulture-energy-rebates-and-incentives",
            layoutId = "gr.tech.site.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.article.initWhyyoushouldPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_article_WhyyoushouldPage()
        }
        ctx.router.register(
            "/blog",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initBlogsPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_BlogsPage()
        }
        ctx.router.register(
            "/blog/green-rebates-cannabis-business-times-2026-best-cannabis-companies-to-work",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.blog.initWemadethelistPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_blog_WemadethelistPage()
        }
        ctx.router.register(
            "/blog/green-rebates-is-back-at-lucky-leaf",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.blog.initLuckyleaf2026Page(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_blog_Luckyleaf2026Page()
        }
        ctx.router.register(
            "/blog/green-rebates-wins-prestigious-2024-seal-sustainable-service-award",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.blog.initGreenreabteswinsprestigiousPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_blog_GreenreabteswinsprestigiousPage()
        }
        ctx.router.register(
            "/blog/hall-of-flowers-2026",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.blog.initHallofflowersPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_blog_HallofflowersPage()
        }
        ctx.router.register(
            "/blog/lucky-leaf-2026",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.blog.initLuckyleafrecapPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_blog_LuckyleafrecapPage()
        }
        ctx.router.register(
            "/blog/necann-boston-2026-recap",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.blog.initNecann2026recapPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_blog_Necann2026recapPage()
        }
        ctx.router.register(
            "/blog/oregon-cannabis-in-2026",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.blog.initOregoncannabis2026Page(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_blog_Oregoncannabis2026Page()
        }
        ctx.router.register(
            "/blog/save-rural-michigan",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.blog.initSaveruralmichiganPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_blog_SaveruralmichiganPage()
        }
        ctx.router.register(
            "/blog/the-thc-girls-and-guy-stopped-by-podcast",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.blog.initThethcgirlsPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_blog_ThethcgirlsPage()
        }
        ctx.router.register(
            "/cannabis-rebates",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.landings.initCannabisRebatesPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_landings_CannabisRebatesPage()
        }
        ctx.router.register(
            "/contact-us",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initContactUsPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_ContactUsPage()
        }
        ctx.router.register(
            "/dehumidifier-rebates",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.landings.initDehumidifierRebatesPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_landings_DehumidifierRebatesPage()
        }
        ctx.router.register(
            "/faq",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initFaqPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_FaqPage()
        }
        ctx.router.register(
            "/financing",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.landings.initFinancingPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_landings_FinancingPage()
        }
        ctx.router.register(
            "/hvac-rebates",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.landings.initHvacRebatesPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_landings_HvacRebatesPage()
        }
        ctx.router.register(
            "/led-grow-light-rebates",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.landings.initLEDRebatesPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_landings_LEDRebatesPage()
        }
        ctx.router.register(
            "/meet-the-team",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initMeetTheTeamPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_MeetTheTeamPage()
        }
        ctx.router.register(
            "/our-services",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.landings.initOurServicesPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_landings_EnergyRebatesIncentivesPage()
        }
        ctx.router.register(
            "/partners",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initPartnersPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_PartnersPage()
        }
        ctx.router.register(
            "/podcast",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initPodcastPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_PodcastPage()
        }
        ctx.router.register(
            "/privacy",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initPrivacyPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_PrivacyPage()
        }
        ctx.router.register(
            "/states",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initStatesPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_StatesPage()
        }
        ctx.router.register(
            "/states/california",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.states.initCaliforniaPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_states_CaliforniaPage()
        }
        ctx.router.register(
            "/states/michigan",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.states.initMichiganPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_states_MichiganPage()
        }
        ctx.router.register(
            "/states/minnesota",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.states.initMinnesotaPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_states_MinnesotaPage()
        }
        ctx.router.register(
            "/states/oregon",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.states.initOregonPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_states_OregonPage()
        }
        ctx.router.register(
            "/states/washington",
            layoutId = "gr.tech.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.states.initWashingtonPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_states_WashingtonPage()
        }
        ctx.router.register(
            "/terms",
            layoutId = "gr.tech.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                gr.tech.site.pages.initTermsPage(ctx)
            },
        ) { pageCtx -> 
            _gr_tech_site_pages_TermsPage()
        }

        gr.tech.site.setCustomErrorPage(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("honeypot-wrapper", gr.tech.site.util.HoneypotWrapperStyle)
        ctx.theme.registerStyle("hero-container", gr.tech.site.styles.HeroContainerStyle)
        ctx.theme.registerStyle("hero-split", gr.tech.site.styles.HeroSplitStyle)
        ctx.theme.registerStyle("hero-photo-cell", gr.tech.site.styles.HeroPhotoCellStyle)
        ctx.theme.registerStyle("hero-copy-cell", gr.tech.site.styles.HeroCopyCellStyle)
        ctx.theme.registerStyle("hero-overlay", gr.tech.site.styles.HeroOverlayStyle)
        ctx.theme.registerStyle("hero-iframe-container", gr.tech.site.styles.HeroIframeContainerStyle)
        ctx.theme.registerStyle("hero-eyebrow", gr.tech.site.styles.HeroEyebrowStyle)
        ctx.theme.registerStyle("hero-h1", gr.tech.site.styles.HeroH1Style)
        ctx.theme.registerStyle("hero-body", gr.tech.site.styles.HeroBodyStyle)
        ctx.theme.registerStyle("hero-cta-row", gr.tech.site.styles.HeroCtaRowStyle)
        ctx.theme.registerStyle("hero-trust-line", gr.tech.site.styles.HeroTrustLineStyle)
        ctx.theme.registerStyle("home-scroll-card-item", gr.tech.site.styles.HomeScrollCardItemStyle)
        ctx.theme.registerStyle("home-testimonial-card", gr.tech.site.styles.HomeTestimonialCardStyle)
        ctx.theme.registerStyle("growers-profile-container", gr.tech.site.styles.GrowersProfileContainer)
        ctx.theme.registerStyle("landing-hero", gr.tech.site.styles.landings.LandingHeroStyle)
        ctx.theme.registerStyle("landing-image", gr.tech.site.styles.landings.LandingImageStyle)
        ctx.theme.registerStyle("landing-hero-eyebrow", gr.tech.site.styles.landings.LandingHeroEyebrowStyle)
        ctx.theme.registerStyle("landing-hero-headline", gr.tech.site.styles.landings.LandingHeroHeadlineStyle)
        ctx.theme.registerStyle("landing-hero-lead", gr.tech.site.styles.landings.LandingHeroLeadStyle)
        ctx.theme.registerStyle("landing-section-heading", gr.tech.site.styles.landings.LandingSectionHeadingStyle)
        ctx.theme.registerStyle("landing-dark-section-heading", gr.tech.site.styles.landings.LandingDarkSectionHeadingStyle)
        ctx.theme.registerStyle("landing-section-subtitle", gr.tech.site.styles.landings.LandingSectionSubtitleStyle)
        ctx.theme.registerStyle("landing-body", gr.tech.site.styles.landings.LandingBodyStyle)
        ctx.theme.registerStyle("landing-muted-body", gr.tech.site.styles.landings.LandingMutedBodyStyle)
        ctx.theme.registerStyle("landing-muted-white-body", gr.tech.site.styles.landings.LandingMutedWhiteBodyStyle)
        ctx.theme.registerStyle("landing-dark-body", gr.tech.site.styles.landings.LandingDarkBodyStyle)
        ctx.theme.registerStyle("landing-step-card-number", gr.tech.site.styles.landings.LandingStepCardNumberStyle)
        ctx.theme.registerStyle("landing-step-card-title", gr.tech.site.styles.landings.LandingStepCardTitleStyle)
        ctx.theme.registerStyle("landing-step-card-body", gr.tech.site.styles.landings.LandingStepCardBodyStyle)
        ctx.theme.registerStyle("landing-rebate-card", gr.tech.site.styles.landings.LandingRebateCardStyle)
        ctx.theme.registerStyle("landing-rebate-card-title", gr.tech.site.styles.landings.LandingRebateCardTitleStyle)
        ctx.theme.registerStyle("landing-rebate-card-body", gr.tech.site.styles.landings.LandingRebateCardBodyStyle)
        ctx.theme.registerStyle("landing-check-icon", gr.tech.site.styles.landings.LandingCheckIconStyle)
        ctx.theme.registerStyle("landing-dark-item-title", gr.tech.site.styles.landings.LandingDarkItemTitleStyle)
        ctx.theme.registerStyle("landing-dark-item-body", gr.tech.site.styles.landings.LandingDarkItemBodyStyle)
        ctx.theme.registerStyle("landing-sub-section-heading", gr.tech.site.styles.landings.LandingSubSectionHeadingStyle)
        ctx.theme.registerStyle("landing-checkmark", gr.tech.site.styles.landings.LandingCheckmarkStyle)
        ctx.theme.registerStyle("landing-testimonial-card", gr.tech.site.styles.landings.LandingTestimonialCardStyle)
        ctx.theme.registerStyle("landing-quote-mark", gr.tech.site.styles.landings.LandingQuoteMarkStyle)
        ctx.theme.registerStyle("landing-attribution", gr.tech.site.styles.landings.LandingAttributionStyle)
        ctx.theme.registerStyle("landing-cta-heading", gr.tech.site.styles.landings.LandingCtaHeadingStyle)
        ctx.theme.registerStyle("landing-cta-body", gr.tech.site.styles.landings.LandingCtaBodyStyle)
        ctx.theme.registerStyle("landing-cta-primary", gr.tech.site.styles.landings.LandingCtaPrimaryStyle)
        ctx.theme.registerStyle("landing-cta-secondary", gr.tech.site.styles.landings.LandingCtaSecondaryStyle)
        ctx.theme.registerStyle("landing-cta-third", gr.tech.site.styles.landings.LandingCtaThirdStyle)
        ctx.theme.registerStyle("landing-cta-outline", gr.tech.site.styles.landings.LandingCtaOutlineStyle)
        ctx.theme.registerStyle("landing-cta-black-outline", gr.tech.site.styles.landings.LandingCtaBlackOutlineStyle)
        ctx.theme.registerStyle("button-hover-outline", gr.tech.site.styles.landings.ButtonHoverOutline)
        ctx.theme.registerStyle("blog-card-hover", gr.tech.site.styles.BlogCardHoverStyle)
        ctx.theme.registerStyle("button-hover-green", gr.tech.site.styles.ButtonHoverGreen)
        ctx.theme.registerStyle("button-hover-dark-green", gr.tech.site.styles.ButtonHoverDarkGreen)
        ctx.theme.registerStyle("button-hover-medium-green", gr.tech.site.styles.ButtonHoverMediumGreen)
        ctx.theme.registerStyle("button-hover-white", gr.tech.site.styles.ButtonHoverWhite)
        ctx.theme.registerStyle("nav-contact-header-text", gr.tech.site.styles.NavContactHeaderTextStyle)
        ctx.theme.registerStyle("nav-link-hover", gr.tech.site.styles.NavLinkHoverStyle)
        ctx.theme.registerStyle("socials-icon", gr.tech.site.styles.SocialsIconStyle)
        ctx.theme.registerStyle("green-gradient-text", gr.tech.site.styles.GreenGradientTextStyle)
        ctx.theme.registerStyle("headline-text", gr.tech.site.styles.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", gr.tech.site.styles.SubheadlineTextStyle)
        ctx.theme.registerStyle("faq-light-accordion", gr.tech.site.styles.FaqLightAccordionStyle)
        ctx.theme.registerStyle("blog-preview-card", gr.tech.site.styles.BlogPreviewCardStyle)
        ctx.theme.registerStyle("dlc-fixture-container", gr.tech.site.styles.DlcFixtureContainerStyle)
        ctx.theme.registerStyle("dlc-eyebrow", gr.tech.site.styles.DlcEyebrowStyle)
        ctx.theme.registerStyle("dlc-horti-badge", gr.tech.site.styles.DlcHortiBadgeStyle)
        ctx.theme.registerStyle("dlc-stat-tile", gr.tech.site.styles.DlcStatTileStyle)
        ctx.theme.registerStyle("dlc-stat-value", gr.tech.site.styles.DlcStatValueStyle)
        ctx.theme.registerStyle("dlc-stat-label", gr.tech.site.styles.DlcStatLabelStyle)
        ctx.theme.registerStyle("california-hero-text", gr.tech.site.styles.states.CaliforniaHeroTextStyle)
        ctx.theme.registerStyle("washington-hero-text", gr.tech.site.styles.states.WashingtonHeroTextStyle)
        ctx.theme.registerStyle("oregon-hero-text", gr.tech.site.styles.states.OregonHeroTextStyle)
        ctx.theme.registerStyle("utility-partner-wrapper", gr.tech.site.styles.states.UtilityPartnerWrapperStyle)
        ctx.theme.registerStyle("utility-partner-card", gr.tech.site.styles.states.UtilityPartnerCardStyle)
        ctx.theme.registerStyle("utility-partner-logo", gr.tech.site.styles.states.UtilityPartnerLogoStyle)
        ctx.theme.registerStyle("utility-partner-content", gr.tech.site.styles.states.UtilityPartnerContentStyle)
        ctx.theme.registerStyle("utility-partner-drawer", gr.tech.site.styles.states.UtilityPartnerDrawerStyle)
        ctx.theme.registerStyle("state-stat-icon", gr.tech.site.styles.states.StateStatIconStyle)
        ctx.theme.registerStyle("state-stat-number", gr.tech.site.styles.states.StateStatNumberStyle)
        ctx.theme.registerStyle("state-stat-label", gr.tech.site.styles.states.StateStatLabelStyle)
        ctx.theme.registerStyle("faq-accordion", gr.tech.site.styles.states.FaqAccordionStyle)
        ctx.theme.registerStyle("michigan-hero-text", gr.tech.site.styles.states.MichiganHeroTextStyle)
        ctx.theme.registerStyle("michigan-hero", gr.tech.site.styles.states.MichiganHeroStyle)
        ctx.theme.registerStyle("minnesota-hero-text", gr.tech.site.styles.states.MinnesotaHeroTextStyle)
        ctx.theme.registerStyle("minnesota-hero", gr.tech.site.styles.states.MinnesotaHeroStyle)
        ctx.theme.registerStyle("team-slider", gr.tech.site.styles.TeamSliderStyle)
        ctx.theme.registerStyle("featured-person-card", gr.tech.site.styles.FeaturedPersonCardStyle)
        ctx.theme.registerStyle("team-member-card", gr.tech.site.styles.TeamMemberCardStyle)
        ctx.theme.registerStyle("team-member-headshot", gr.tech.site.styles.TeamMemberHeadshotStyle)
        ctx.theme.registerStyle("featured-person-image", gr.tech.site.styles.FeaturedPersonImageStyle)
        ctx.theme.registerStyle("contact-us-header", gr.tech.site.styles.ContactUsHeader)
        ctx.theme.registerStyle("contact-us-description", gr.tech.site.styles.ContactUsDescription)
        ctx.theme.registerStyle("contact-info-divider", gr.tech.site.styles.ContactInfoDividerStyle)
        ctx.theme.registerStyle("contact-info-title", gr.tech.site.styles.ContactInfoTitleStyle)
        ctx.theme.registerStyle("contact-info-subtext", gr.tech.site.styles.ContactInfoSubtextStyle)
        ctx.theme.registerStyle("contact-info-link-text", gr.tech.site.styles.ContactInfoLinkTextStyle)
        ctx.theme.registerStyle("contact-info-icon", gr.tech.site.styles.ContactInfoIconStyle)
        ctx.theme.registerStyle("form-input-label", gr.tech.site.styles.FormInputLabelStyle)
        ctx.theme.registerStyle("contact-us-section-header", gr.tech.site.styles.ContactUsSectionHeader)
        ctx.theme.registerStyle("contact-us-section-subtitle", gr.tech.site.styles.ContactUsSectionSubtitle)
        ctx.theme.registerStyle("room-use-tutorial", gr.tech.site.styles.RoomUseTutorialStyle)
        ctx.theme.registerStyle("contact-input", gr.tech.site.styles.ContactInputStyle)
        ctx.theme.registerStyle("room-use-responsive", gr.tech.site.styles.roomUseResponsiveStyle)
        ctx.theme.registerStyle("input-style-half", gr.tech.site.styles.InputStyleHalf)
        ctx.theme.registerStyle("input-column", gr.tech.site.styles.InputColumn)
        ctx.theme.registerStyle("input-column-half", gr.tech.site.styles.InputColumnHalf)
        ctx.theme.registerStyle("contact-row", gr.tech.site.styles.ContactRow)
        ctx.theme.registerStyle("responsive-columns", gr.tech.site.styles.ResponsiveColumns)
        ctx.theme.registerStyle("submit-button", gr.tech.site.styles.SubmitButtonStyle)
        ctx.theme.registerStyle("state-card", gr.tech.site.styles.StateCardStyle)
        ctx.theme.registerStyle("state-abbr", gr.tech.site.styles.StateAbbrStyle)
        ctx.theme.registerStyle("state-name", gr.tech.site.styles.StateNameStyle)
        ctx.theme.registerStyle("state-footer", gr.tech.site.styles.StateFooterStyle)
        ctx.theme.registerStyle("state-page-arrow", gr.tech.site.styles.StatePageArrowStyle)
        ctx.theme.registerStyle("utility-modal-card", gr.tech.site.styles.UtilityModalCardStyle)
        ctx.theme.registerStyle("utility-modal-header", gr.tech.site.styles.UtilityModalHeaderStyle)
        ctx.theme.registerStyle("utility-modal-close", gr.tech.site.styles.UtilityModalCloseStyle)
        ctx.theme.registerStyle("utility-modal-body", gr.tech.site.styles.UtilityModalBodyStyle)
        ctx.theme.registerStyle("utility-modal-footer", gr.tech.site.styles.UtilityModalFooterStyle)
        ctx.theme.registerStyle("modal-footer-state-page", gr.tech.site.styles.ModalFooterStatePageStyle)
        ctx.theme.registerStyle("modal-footer-contact", gr.tech.site.styles.ModalFooterContactStyle)
        ctx.theme.registerStyle("utility-row", gr.tech.site.styles.UtilityRowStyle)
        ctx.theme.registerStyle("utility-row-arrow", gr.tech.site.styles.UtilityRowArrowStyle)
        ctx.theme.registerStyle("footer-link", gr.tech.site.components.sections.FooterLinkStyle)
        ctx.theme.registerStyle("footer", gr.tech.site.components.sections.FooterStyle)
        ctx.theme.registerStyle("partner-logo", gr.tech.site.components.sections.partnerLogoStyle)
        ctx.theme.registerStyle("partner-card-header", gr.tech.site.components.sections.partnerCardHeaderStyle)
        ctx.theme.registerStyle("nav-header-logo", gr.tech.site.components.sections.NavHeaderLogoStyle)
        ctx.theme.registerStyle("nav-header", gr.tech.site.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("contact-header", gr.tech.site.components.sections.ContactHeaderStyle)
        ctx.theme.registerStyle("related-section-link", gr.tech.site.components.sections.RelatedSectionLinkStyle)
        ctx.theme.registerStyle("logos-section", gr.tech.site.components.sections.LogosSectionStyle)
        ctx.theme.registerStyle("logos-section-compact", gr.tech.site.components.sections.LogosSectionCompactStyle)
        ctx.theme.registerStyle("logos-slide", gr.tech.site.components.sections.LogosSlideStyle)
        ctx.theme.registerStyle("partner-animated-logo", gr.tech.site.components.sections.PartnerAnimatedLogoStyle)
        ctx.theme.registerStyle("markdown", gr.tech.site.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content", gr.tech.site.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("article", gr.tech.site.components.layouts.ArticleStyle)
        ctx.theme.registerStyle("modal-overlay", gr.tech.site.components.ModalOverlayStyle)
        ctx.theme.registerStyle("modal-content-animation", gr.tech.site.components.ModalContentAnimation)
        ctx.theme.registerStyle("podcast-card", gr.tech.site.pages.PodcastCardStyle)
        ctx.theme.registerStyle("play-icon", gr.tech.site.pages.PlayIconStyle)
        ctx.theme.registerVariant("-circle", gr.tech.site.styles.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", gr.tech.site.styles.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("dropdown-fade-in", gr.tech.site.components.sections.DropdownFadeInAnim)
        ctx.theme.registerKeyframes("side-menu-slide-in", gr.tech.site.components.sections.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("overlay-fade-in", gr.tech.site.components.sections.OverlayFadeInAnim)
        ctx.theme.registerKeyframes("overlay-fade-out", gr.tech.site.components.sections.OverlayFadeOutAnim)
        ctx.theme.registerKeyframes("slide", gr.tech.site.components.sections.slide)
        ctx.theme.registerKeyframes("slide-right", gr.tech.site.components.sections.slideRight)
        ctx.theme.registerKeyframes("modal-overlay-fade-in", gr.tech.site.components.ModalOverlayFadeInAnimation)
        ctx.theme.registerKeyframes("modal-content-slide-up", gr.tech.site.components.ModalContentSlideUpAnimation)
        gr.tech.site.styles.initSiteStyles(ctx)
        gr.tech.site.initStyles(ctx)
        gr.tech.site.initTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        gr.tech.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
